<app-modal [info]="info" (closeModal)="closeModal()" (onSubmit)="onSubmit()">
  <ng-template #textContent>
    <p class="modal__text">
      @if (data.type === 'move') {
        {{ 'FOLDERS.FOLDER_PAGE.CANDIDATE_ACTIONS.MODALS.MOVE.MOVE' | translate }}
        <ng-container [ngTemplateOutlet]="candidateInfo"></ng-container>
      }
      @if (data.type === 'duplicate') {
        {{ 'FOLDERS.FOLDER_PAGE.CANDIDATE_ACTIONS.MODALS.MOVE.DUPLICATE' | translate }}
        <ng-container [ngTemplateOutlet]="candidateInfo"></ng-container>
      }
    </p>
  </ng-template>

  <ng-template #scrollableContent>
    <div class="folders">
      @for (folder of form.value; track folder) {
        <app-folder-card-small
          class="folders__item"
          [type]="'simple'"
          [folder]="folder"
          [candidateFullName]="data?.candidateName"
          (clickFolder)="choseFolder(folder)"></app-folder-card-small>
      }
    </div>
  </ng-template>
</app-modal>

<ng-template #candidateInfo>
  @if (data?.candidateName) {
    {{ data.candidateName | translate }}
  }
  @if (data?.candidateLength > 1) {
    {{ data.candidateLength | numberWithSpaces }}
    {{ data.candidateLength | currentNumeric: 'PROFILE' | translate }}
  }
</ng-template>
